import axios from '@/libs/api.request'

/**
 * 单孔统计
 */
export const holeStatistic = (hole_id) => {
    const data ={
        "hole_id": hole_id,
    }
    return axios.request({
        url: '/api/admin/statistic/hole',
        data,
        method: 'post'
    })
}

/**
 * 获取单元下面的在几个序
 */
export const getUnitOrder = (pid4, a) => {
    const data ={
        "pid4": pid4,
        "a": a
    }
    return axios.request({
        url: '/api/admin/statistic/getUnitOrder',
        data,
        method: 'post'
    })
}

/**
 * 分序统计
 */
export const orderData = (pid4, order) => {
    const data ={
        "pid4": pid4,
        "order": order,
    }
    return axios.request({
        url: '/api/admin/statistic/order',
        data,
        method: 'post'
    })
}

/**
 * 分序统计导出
 */
export const exportOrder = (pid4, order) => {
    const data ={
        "pid4": pid4,
        "order": order,
    }
    return axios.request({
        url: '/api/admin/statistic/exportOrder',
        data,
        method: 'post'
    })
}


/**
 * 单元统计
 */
export const unitData = (pid4) => {
    const data ={
        "pid4": pid4
    }
    return axios.request({
        url: '/api/admin/statistic/unit',
        data,
        method: 'post'
    })
}

/**
 * 单元统计导出
 */
export const exportUnit = (pid4) => {
    const data ={
        "pid4": pid4
    }
    return axios.request({
        url: '/api/admin/statistic/exportUnit',
        data,
        method: 'post'
    })
}

/**
 * 检查选择的是否是分部
 */
export const checkBranch = (pid3) => {
    const data ={
        "pid3": pid3
    }
    return axios.request({
        url: '/api/admin/statistic/checkBranch',
        data,
        method: 'post'
    })
}

/**
 * 分部统计
 */
export const branchData = (pid3) => {
    const data ={
        "pid3": pid3
    }
    return axios.request({
        url: '/api/admin/statistic/branch',
        data,
        method: 'post'
    })
}

/**
 * 分部统计导出
 */
export const exportBranch = (pid3) => {
    const data ={
        "pid3": pid3
    }
    return axios.request({
        url: '/api/admin/statistic/exportBranch',
        data,
        method: 'post'
    })
}

/**
 * 检查选择的是否是单位工程
 */
export const checkCompany = (pid2) => {
    const data ={
        "pid2": pid2
    }
    return axios.request({
        url: '/api/admin/statistic/checkCompany',
        data,
        method: 'post'
    })
}

/**
 * 单位统计
 */
export const companyData = (pid2) => {
    const data ={
        "pid2": pid2
    }
    return axios.request({
        url: '/api/admin/statistic/company',
        data,
        method: 'post'
    })
}

/**
 * 导出单位统计
 */
export const exportCompany = (pid2) => {
    const data ={
        "pid2": pid2
    }
    return axios.request({
        url: '/api/admin/statistic/exportCompany',
        data,
        method: 'post'
    })
}

/**
 * 单元统计对比分析
 */
export const unitVerifyData = (pid4, report_type) => {
    const data ={
        "pid4": pid4,
        "report_type": report_type
    }
    return axios.request({
        url: '/api/admin/statistic/unitVerify',
        data,
        method: 'post'
    })
}

/**
 * 单元统计对比分析 - 导出
 */
export const exportUnitVerifyData = (pid4, report_type) => {
    const data ={
        "pid4": pid4,
        "report_type": report_type
    }
    return axios.request({
        url: '/api/admin/statistic/exportUnitVerify',
        data,
        method: 'post'
    })
}

/**
 * 分部统计对比分析
 */
export const branchVerifyData = (pid3, report_type) => {
    const data ={
        "pid3": pid3,
        "report_type": report_type
    }
    return axios.request({
        url: '/api/admin/statistic/branchVerify',
        data,
        method: 'post'
    })
}

/**
 * 分部统计对比分析 - 导出
 */
export const exportBranchVerifyData = (pid3, report_type) => {
    const data ={
        "pid3": pid3,
        "report_type": report_type
    }
    return axios.request({
        url: '/api/admin/statistic/exportBranchVerify',
        data,
        method: 'post'
    })
}

/**
 * 单位统计对比分析
 */
export const companyVerifyData = (pid2, report_type) => {
    const data ={
        "pid2": pid2,
        "report_type": report_type
    }
    return axios.request({
        url: '/api/admin/statistic/companyVerify',
        data,
        method: 'post'
    })
}

/**
 * 单位统计对比分析 - 导出
 */
export const exportCompanyVerifyData = (pid2, report_type) => {
    const data ={
        "pid2": pid2,
        "report_type": report_type
    }
    return axios.request({
        url: '/api/admin/statistic/exportCompanyVerify',
        data,
        method: 'post'
    })
}

/**
 * 监测数据对比分析
 */
export const workReportList = (hole_id, segment_no, report_type) => {
    const data ={
        "hole_id": hole_id,
        "segment_no": segment_no,
        "report_type": report_type
    }
    return axios.request({
        url: '/api/admin/verify/workReportList',
        data,
        method: 'post'
    })
}

/**
 * 监测数据对比分析 - 3种报告对比
 */
 export const workReportListContrast = (hole_id, segment_no) => {
    const data ={
        "hole_id": hole_id,
        "segment_no": segment_no,
    }
    return axios.request({
        url: '/api/admin/verify/workReportListForContrast',
        data,
        method: 'post'
    })
}

/**
 * 监测数据对比分析
 */
export const verifyCheck = (hole_id, report_type, is_error) => {
    const data ={
        "hole_id": hole_id,
        "report_type": report_type,
        "is_error": is_error,
    }
    return axios.request({
        url: '/api/admin/verify/check',
        data,
        method: 'post'
    })
}

/**
 * 监测数据对比分析
 */
export const verifyCheckInfo = (report_id, report_type) => {
    const data ={
        "report_id": report_id,
        "report_type": report_type
    }
    return axios.request({
        url: '/api/admin/verify/checkInfo',
        data,
        method: 'post'
    })
}

/**
 * 监测数据对比分析 - 3种报告对比
 */
 export const verifyCheckInfoContrast = (report_id) => {
    const data ={
        "report_id": report_id
    }
    return axios.request({
        url: '/api/admin/verify/checkInfoForContrast',
        data,
        method: 'post'
    })
}

/**
 * 保存数据验证处置结果
*/
export const saveVerifyResult = (result_type, report_id, hole_id, segment_no, verify_result, remark) => {
    const data ={
        "result_type": result_type,
        "report_id": report_id,
        "hole_id": hole_id,
        "segment_no": segment_no,
        "verify_result": verify_result,
        "remark": remark
    }
    return axios.request({
        url: '/api/admin/verify/saveVerifyResult',
        data,
        method: 'post'
    })
}

/**
 * 导出单元中灌浆孔的数据列表
*/
export const verifyExportUnit = (report_type, pid4, hole_code, is_error) => {
    const data ={
        "report_type": report_type,
        "pid4": pid4,
        "hole_code": hole_code,
        "is_error": is_error
    }
    return axios.request({
        url: '/api/admin/verify/exportUnit',
        data,
        method: 'post'
    })
}

/**
 * 导出灌浆孔中段的差异列表
*/
export const verifyExportHole = (report_type, hole_id) => {
    const data ={
        "report_type": report_type,
        "hole_id": hole_id
    }
    return axios.request({
        url: '/api/admin/verify/exportHole',
        data,
        method: 'post'
    })
}

/**
 * 导出对比报告PDF
*/
export const exportVerifyReport = (report_type, hole_id, segment_no) => {
    const data ={
        "report_type": report_type,
        "hole_id": hole_id,
        "segment_no": segment_no
    }
    return axios.request({
        url: '/api/admin/verify/exportVerifyReport',
        data,
        method: 'post'
    })
}
/**
 * 重新生成对比报告
*/
export const reCreateVerifyReport = (report_id, report_type) => {
    const data ={
        "report_id": report_id,
        "report_type": report_type
    }
    return axios.request({
        url: '/api/admin/verify/reCreateVerifyReport',
        data,
        method: 'post'
    })
}

/**
 * 批量重新生成对比报告
*/
export const reCreateVerifyReportBatch = (result_ids, report_type) => {
    const data ={
        "result_ids": result_ids,
        "report_type": report_type
    }
    return axios.request({
        url: '/api/admin/reportdealresult/reCreateVerifyReportBatch',
        data,
        method: 'post'
    })
}

/**
 * 批量自动处置报告
*/
export const autoDealBatch = (report_type) => {
    const data ={
        "report_type": report_type
    }
    return axios.request({
        url: '/api/admin/reportdealresult/autoDealBatch',
        data,
        method: 'post'
    })
}

/**
 * 获取报告数量
*/
export const reportCount = (pid) => {
    const data ={
        "pid": pid
    }
    return axios.request({
        url: '/api/admin/statistic/reportCount',
        data,
        method: 'post'
    })
}

/**
 * 导出对比分析报告Excel
*/
export const exportVerifyExcel = (pid, grade, report_type, start_date, end_date) => {
    const data ={
        "pid": pid,
        "grade": grade,
        "report_type": report_type,
        "start_date": start_date,
        "end_date": end_date
    }
    return axios.request({
        url: '/api/admin/verify/exportVerifyExcel',
        data,
        method: 'post'
    })
}

/**
 * 数据监测与分析 - 导出PDF (整个单元)
*/
export const exportVerifyReportPDFByUnit = (pid4, report_type, start_date, end_date) => {
    const data ={
        "pid4": pid4,
        "report_type": report_type,
        "start_date": start_date,
        "end_date": end_date
    }
    return axios.request({
        url: '/api/admin/verify/exportVerifyReportPDFByUnit',
        data,
        method: 'post'
    })
}

/**
 * 重新生成对比报告1
*/
export const createVerifyFromFile = (report_type, hole_id, segment_no) => {
    const data ={
        "report_type": report_type,
        "hole_id": hole_id,
        "segment_no": segment_no
    }
    return axios.request({
        url: '/api/admin/verify/createVerifyFromFile',
        data,
        method: 'post'
    })
}